module.exports = __webpack_public_path__ + "img/ANTENNA 5 RED.eb6c0d4.svg";